<template>
  <div class="view">
    <div class="header">
      Dashboard
    </div>
    <div class="content">
      <div class="tiles">
        <shipped-orders-tile @updated="$refs.outstanding.fetchData()" />
        <outstanding-orders-tile ref="outstanding" />
        <orders-placed-tile @updated="$refs.outstanding.fetchData()" />
      </div>
      <div class="cameras">
        <div class="camera">
          <iframe
            type="text/html"
            frameborder="0"
            width="100%"
            height="100%"
            src="//video.nest.com/embedded/live/nmLZnYJp5P?autoplay=1"
            allowfullscreen
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import dateFormat from 'dateformat'
import { db } from '../firebase'
import axios from 'axios'

Vue.component('OutstandingOrdersTile', {
  data() {
    return {
      count: 0,
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const result = await axios({
        url: 'https://api.newtype.app/order-outstandingCount',
        method: 'get',
      })

      this.count = result.data.count
    },
  },
  template: `
    <div class="tile">
      <div class="count">{{ count }}</div>
      <div class="label">Outstanding</div>
    </div>
  `,
})

Vue.component('ShippedOrdersTile', {
  data() {
    return {
      count: 0,
      unsubscribe: null,
    }
  },
  mounted() {
    this.newDay()
  },
  methods: {
    newDay() {
      this.unsubscribe = db
        .collection('analytics')
        .doc(dateFormat(Date.now(), 'yyyy-mm-dd'))
        .onSnapshot((doc) => {
          this.count = doc.get('ordersFulfilled')
          this.$emit('updated')
        })
    },
  },
  template: `
    <div class="tile">
      <div class="count">{{ count }}</div>
      <div class="label">Shipped</div>
    </div>
  `,
})

Vue.component('OrdersPlacedTile', {
  data() {
    return {
      count: 0,
      unsubscribe: null,
    }
  },
  mounted() {
    this.newDay()
  },
  methods: {
    newDay() {
      this.unsubscribe = db
        .collection('analytics')
        .doc(dateFormat(Date.now(), 'yyyy-mm-dd'))
        .onSnapshot((doc) => {
          this.count = doc.get('ordersPlaced')
          this.$emit('updated')
        })
    },
  },
  template: `
    <div class="tile">
      <div class="count">{{ count }}</div>
      <div class="label">New</div>
    </div>
  `,
})

export default {}
</script>

<style lang="scss" scoped>
.content {
  display: grid;
  grid-template-columns: 1fr 4fr;
  grid-gap: 20px;

  ::v-deep .tiles {
    grid-column: 1;
    grid-row: 1;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;

    .tile {
      width: 100%;
      height: 200px;
      background-color: $darkHeaderBackgroundColor;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: $darkStrongColor;
      text-align: center;
      text-transform: uppercase;
      line-height: 1;

      .label {
        font-size: 2vw;
      }
      .count {
        font-size: 7vw;
      }
    }
  }

  .cameras {
    grid-column: 2;
    grid-row: 1;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;

    .camera {
      width: 100%;
      grid-column: 1;
    }
  }
}
</style>
